module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 05 > WLAN Upload.0af7e337.jpg";